module.exports = __webpack_public_path__ + "static/media/porcen.12a97f66.png";